import { render, staticRenderFns } from "./GoalWidgetPreview.vue?vue&type=template&id=38038ec8"
import script from "./GoalWidgetPreview.vue?vue&type=script&lang=js"
export * from "./GoalWidgetPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports